import { checkPhoneNumberValid } from '@ukpostbox/client-data/lib/Endpoints/ValidationEndpoints';
import { FormWrapperLabel, TelephoneControl, useDebounce, ValidationPatterns } from '@ukpostbox/frontend-framework';
import { ControllerFieldState } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import React, { useEffect, useRef, useState } from 'react';

type ValidTelephoneType = {
	name: string;
	defaultValue: string;
	placeholder: string;
	changeCallback: (value: string) => void;
	lookupActiveCallback: (state: boolean) => void;
	validationCallback: (message: string, resetErrors: boolean) => void;
	fieldState?: ControllerFieldState;
};

function ValidTelephone(props: ValidTelephoneType) {
	const [telValid, setTelValid] = useState<boolean>(
		props.defaultValue ? ValidationPatterns.telephone.test(props.defaultValue) : false,
	);
	const [lookupActive, setLookupActive] = useState<boolean>(false);

	const telValueRef = useRef<string>(props.defaultValue);
	const telDebounceValue = useDebounce(telValueRef.current, telValid ? 1000 : 0);

	const HandleChange = (e: string | null) => {
		if (e) {
			telValueRef.current = e;
			props.changeCallback(e);
			setTelValid(ValidationPatterns.telephone.test(e));
		}
	};

	const CheckValidTelephoneNumber = (value: string) => {
		if (!telValid) return;

		setLookupActive(true);
		props.lookupActiveCallback(true);

		checkPhoneNumberValid(value)
			.then((r: { isValid: boolean }) => {
				props.validationCallback('Telephone format is invalid', r.isValid);
			})
			.catch((e: any) => {
				props.validationCallback(`Something went wrong ${e}`, false);
			})
			.finally(() => {
				setLookupActive(false);
				props.lookupActiveCallback(false);
			});
	};

	useEffect(() => {
		if (telDebounceValue?.debouncedValue && telDebounceValue.debouncedValue !== '') {
			CheckValidTelephoneNumber(telDebounceValue.debouncedValue);
		}
	}, [telDebounceValue.debouncedValue]);

	return (
		<FormWrapperLabel
			label='Phone Number'
			invalid={props.fieldState?.invalid}
			validationMessage={props.fieldState?.error?.message}
			active={lookupActive}
		>
			<TelephoneControl
				name={props.name}
				defaultValue={props.defaultValue}
				placeholder='Phone Number'
				onChange={(e) => HandleChange(e)}
			/>
		</FormWrapperLabel>
	);
}

export { ValidTelephone };
